import BikramSambat, {ADToBS, BSToAD}  from "bikram-sambat-js"
import { useSelector } from "react-redux";
import { RootState } from "../store/store";

export const NepNowDateFormat = () => {
    const { SET_FULL_SOFT_DATA } = useSelector((state: RootState) => state.software);
    return SET_FULL_SOFT_DATA?.today_np;
}

// 2080/11/03 - 2024/10/20
export const BSToADUSFormat = (dates?: string): string => {
    const NepaliDate = require('nepali-date');
    const NepaliMonth = new NepaliDate(dates ? dates : "");
    const year = NepaliMonth.format("YYYY");
    const day = NepaliMonth.format("DD");
    const month = NepaliMonth.format("MM");
    const NPBSToAD = `${year}-${month}-${day}`
    const convertedNepaliDate = BSToAD(NPBSToAD ? NPBSToAD : "");
    const ENDate = new Date(convertedNepaliDate ? convertedNepaliDate : "");
    const en_year = ENDate.getFullYear();
    const en_month = String(ENDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const en_day = String(ENDate.getDate()).padStart(2, '0');
    return `${en_year}/${en_month}/${en_day}`;
}

// 2024-01-22 - 2080/10/08
export const ADToBSConvert = (date?: string): string => {
    const NepaliDate = require('nepali-date');
    const convertedNepaliDate = ADToBS(date ? date : "");
    let NPDate = new NepaliDate(convertedNepaliDate);
    return NPDate.format('YYYY/MM/DD');
}
export const getMonth = (date?: string): string => {
    const NepaliDate = require('nepali-date');
    const convertedNepaliDate = ADToBS(date ? date : "");
    let NPDate = new NepaliDate(convertedNepaliDate);
     const nep_date =NPDate.format('YYYY-MM-DD');
    let nep_date_for = new NepaliDate(nep_date)
    const NepaliMonth = new NepaliDate(nep_date_for);
    return NepaliMonth.format("MM");
}
export const getYear = (date?: string): string => {
    const NepaliDate = require('nepali-date');
    const convertedNepaliDate = ADToBS(date ? date : "");
    let NPDate = new NepaliDate(convertedNepaliDate);
     const nep_date =NPDate.format('YYYY-MM-DD');
    let nep_date_for = new NepaliDate(nep_date)
    const NepaliMonth = new NepaliDate(nep_date_for);
    return NepaliMonth.format("YYYY");
}
export const NowNepaliYearName = () => {
    const date = new Date()
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const DefaultADDate = `${year}-${month}-${day}`;
    const NepaliDate = require('nepali-date');
    const convertedNepaliDate = ADToBS(DefaultADDate ? DefaultADDate : "");
    let NPDate = new NepaliDate(convertedNepaliDate)
    const NepaliMonth = new NepaliDate(NPDate || "2080/08/24");
    return NepaliMonth.format("YYYY");
}
export const EngNowDateFormat = () => {
    const date = new Date()
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
};
export const NowNepaliMonthName = () => {
    const date = new Date()
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const DefaultADDate = `${year}-${month}-${day}`;
    const NepaliDate = require('nepali-date');
    const convertedNepaliDate = ADToBS(DefaultADDate ? DefaultADDate : "");
    let NPDate = new NepaliDate(convertedNepaliDate)
    const NepaliMonth = new NepaliDate(NPDate || "2080/08/24");
    return NepaliMonth.format("MM");
}
// 2080/10/08 - 2080.10.08
export const NepaliACDateFormat = (date:any) => {
    const NepaliDate = require('nepali-date');
    let NPDate = new NepaliDate(date);
    return NPDate.format('YYYY.MM.DD');
}

